(function () {
  'use strict';
  if (document.documentElement.lang.toLowerCase() !== 'da') return;
  var marker = document.getElementById('gw-da-dk-entry-20261022-v1');
  if (!marker || marker.getAttribute('data-gw-da-dk-country') !== 'DK') return;
  var root = (marker.getAttribute('data-gw-da-dk-root') || '').replace(/\/+$/, '');
  var path = window.location.pathname.replace(/\/+$/, '');
  if (!/^\/da(?:-dk)?$/.test(root) || path !== (marker.getAttribute('data-gw-da-dk-path') || '').replace(/\/+$/, '')) return;
  var key = marker.getAttribute('data-gw-da-dk-entry');
  var tails = {
    recorder: '/pages/gladwares-ai-recorder', cart: '/cart', faq: '/pages/faqs',
    contact: '/pages/content', refund: '/policies/refund-policy',
    privacy: '/policies/privacy-policy', shipping: '/policies/shipping-policy',
    terms: '/policies/terms-of-service', tracking: '/apps/17TRACK',
    recorder_product: '/products/magnetic-ai-powered-voice-recorder',
    headphones: '/products/2026-noise-cancelling-wireless-headphones',
    hub: '/products/8-in-1-dual-usb-c-hub',
    folding_keyboard: '/products/folding-keyboard-with-smart-trackpad',
    air_mouse: '/products/mini-m5-dual-mode-wireless-air-mouse-keyboard'
  };
  if (!tails[key] || path.toLowerCase() !== (root + tails[key]).toLowerCase()) return;
  var images;
  try { images = JSON.parse(marker.textContent).images; } catch (error) { return; }
  var alts = {
    "lux-img-1": "Gladwares MemoryCard AI Pro — optagelse, transskription og opsummering",
    "lux-img-1-1": "Gladwares MemoryCard AI Pro — optagelse, transskription og opsummering",
    "lux-img-2": "Fra samtale til overskuelig tekst",
    "lux-img-3": "Transskription på 152 sprog",
    "lux-img-4": "Transskription, hovedpunkter og opgaver",
    "lux-img-5": "Privatliv og lokal lagring",
    "lux-img-6": "Optag telefonopkald og samtaler ansigt til ansigt",
    "lux-img-7-1": "Kundesamtaler",
    "lux-img-7-2": "Samtaler og undervisning",
    "lux-img-7-3": "Møder og arbejde på farten",
    "lux-img-7-4": "Idéer og indhold",
    "lux-img-8-1": "Overskuelige mødetransskriptioner",
    "lux-img-8-2": "Fremhæv vigtige punkter",
    "lux-img-8-3": "Mødeopsummering med hovedpunkter, beslutninger og næste skridt",
    "lux-img-8-4": "Afspilning fra opsummeringen",
    "lux-img-9-1": "Opgaver og opfølgende e-mails",
    "lux-img-9-2": "Overblik over kundeoplysninger",
    "lux-img-9-3": "AI-forslag til næste skridt baseret på samtalens indhold",
    "lux-img-9-4": "Kundeprofil, der suppleres med oplysninger fra flere samtaler",
    "P5-1": "Optag med ét tryk",
    "P5-2": "Transskription og opsummering uden abonnement",
    "P5-3": "152 sprog i DOWAY-appen",
    "P5-4": "Optag, transskriber og opsummer",
    "P5-5": "64 GB — op til 450 timers optagelse",
    "P5-6": "Tynd magnetisk optager i kortformat"
};
  function setImage(img, id) {
    var url = images[id];
    if (!img || img.tagName !== 'IMG' || !url) return;
    var hero = id === 'lux-img-1' || id === 'lux-img-1-1';
    var mobile = window.matchMedia('(max-width: 767.4999px)').matches;
    if (hero) {
      var visible = mobile ? id === 'lux-img-1-1' : id === 'lux-img-1';
      img.setAttribute('loading', visible ? 'eager' : 'lazy');
      img.setAttribute('fetchpriority', visible ? 'high' : 'auto');
    }
    if (img.getAttribute('src') !== url) img.setAttribute('src', url);
    img.setAttribute('data-src', url);
    img.setAttribute('data-srcset', url);
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('alt', alts[id] || '');
    var picture = img.closest('picture');
    if (picture) picture.querySelectorAll('source').forEach(function (source) {
      source.setAttribute('srcset', url);
      source.setAttribute('data-srcset', url);
    });
  }
  function imagesOnce() {
    if (key !== 'recorder') return;
    Object.keys(images).forEach(function (id) {
      if (id.indexOf('lux-img-') === 0) setImage(document.getElementById(id), id);
    });
    var thumbs = document.querySelectorAll('#lux-thumb-strip .lux-thumb');
    if (thumbs.length !== 6) return;
    thumbs.forEach(function (thumb, index) {
      var id = 'P5-' + (index + 1);
      thumb.setAttribute('data-da-image', images[id]);
      thumb.setAttribute('data-da-dk-image', images[id]);
      thumb.setAttribute('data-image', images[id]);
      thumb.setAttribute('aria-label', alts[id]);
      setImage(thumb.querySelector('img'), id);
    });
    var active = document.querySelector('#lux-thumb-strip .lux-thumb.is-active') || thumbs[0];
    setImage(document.getElementById('lux-main-image'), 'P5-' + (Array.prototype.indexOf.call(thumbs, active) + 1));
  }
  function localLinks(container) {
    var permitted = Object.keys(tails).map(function (name) { return tails[name].toLowerCase(); });
    container.querySelectorAll('a[href]').forEach(function (a) {
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.origin); } catch (error) { return; }
      if (url.origin === window.location.origin) {
        var relative = url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
        if (permitted.indexOf(relative.replace(/\/+$/, '').toLowerCase()) !== -1) {
          var target = root + relative + url.search + url.hash;
          if (a.getAttribute('href') !== target) a.setAttribute('href', target);
        }
      } else if (url.hostname === 'shopify.com' && url.pathname === '/9182642261/account/orders') {
        url.searchParams.set('locale', 'da');
        url.searchParams.set('region_country', 'DK');
        a.setAttribute('href', url.href);
      }
    });
  }
  function bundleText() {
    document.querySelectorAll('#lux-bundle-area .engrave-input').forEach(function (input) {
      input.setAttribute('placeholder', 'Indtast dit navn eller din tekst');
    });
  }
  function miniCartText() {
    document.querySelectorAll('.mini-cart__item').forEach(function (item) {
      if (!item.querySelector('a[href*="/products/magnetic-ai-powered-voice-recorder"]')) return;
      item.querySelectorAll('.line-item').forEach(function (line) {
        if (line.childElementCount === 0 && /^\s*Engraving(?=\s|:|\d|$)/.test(line.textContent)) {
          line.textContent = line.textContent.replace(/^(\s*)Engraving/, '$1Gravering');
        }
      });
    });
    document.querySelectorAll('.cart_content').forEach(localLinks);
  }
  function galleryAltSync() {
    if (key !== 'recorder' || typeof MutationObserver === 'undefined') return;
    var main = document.getElementById('lux-main-image');
    if (!main) return;
    function sync() {
      var source = main.getAttribute('src');
      for (var index = 1; index <= 6; index++) {
        var id = 'P5-' + index;
        if (source === images[id]) {
          main.setAttribute('alt', alts[id] || '');
          return;
        }
      }
    }
    sync();
    new MutationObserver(sync).observe(main, {attributes: true, attributeFilter: ['src']});
  }

  function init() {
    imagesOnce();
    galleryAltSync();
    localLinks(document);
    bundleText();
    miniCartText();
    var bundle = key === 'recorder' ? document.getElementById('lux-bundle-area') : null;
    if (bundle && typeof MutationObserver !== 'undefined') {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          bundleText();
        });
      }).observe(bundle, {childList: true, subtree: true});
    }
    document.addEventListener('gw-da-dk-cart-rendered', miniCartText);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();

